module.exports = __webpack_public_path__ + "static/media/Footer.aec5d2a2.png";